import React from 'react';
import { Box, Typography } from '@mui/material';
import UsuarioForm from '../components/usuario/UsuarioForm';

const UsuarioNovo: React.FC = () => {
  return (
    <Box>
      <Typography 
        variant="h4" 
        component="h1" 
        gutterBottom 
        sx={{ 
          fontWeight: 'bold',
          fontFamily: 'Arial, sans-serif',
          fontSize: '2.125rem',
          lineHeight: 1.235
        }}
      >
        Novo Usuário
      </Typography>
      <UsuarioForm />
    </Box>
  );
};

export default UsuarioNovo;
